// menucomponent/BottomBar.js
// Added contact button if showContactInfo, with icon (using phone icon emoji as relevant to contact)

import React from "react";

export default function BottomBar({ showAskMe, setShowAskPopup, handleCartClick, totalItems, shareMenu, showContactInfo, handleContactClick }) {
  return (
    <div className="menu-bottom-bar">
      {showAskMe && <button className="menu-ask-btn" onClick={() => setShowAskPopup(true)}>💬 Ask Me</button>}
      <button className="menu-cart-btn" onClick={handleCartClick}>My Selection ({totalItems})</button>
      <button className="share-btn" onClick={shareMenu}>Share</button>
      {showContactInfo && <button className="menu-contact-btn" onClick={handleContactClick}>📞 Contact</button>}
    </div>
  );
}